<template>
  <UserInfoPanel />
  <AlertsContainer :card-data="props.cardData" :props="props.inputs" />
</template>

<script lang="ts" setup>
import { SupportedCardConfigType } from '@notifi-network/notifi-frontend-client';
import { AlertsContainer, UserInfoPanel } from '.';

const props = defineProps<{
  cardData: SupportedCardConfigType;
  inputs?: Record<string, string | undefined>;
}>();
</script>
